import { createSlice } from "@reduxjs/toolkit";

/* eslint-disable no-param-reassign */

const pageNameSlice = createSlice({
  name: "pagename",
  initialState: {
    pagename: null
  },
  reducers: {
    setPageName: (state, action) => {
      state.pagename = action.payload;
    },
    clearPageName: (state) => {
      state.pagename = null;
    }
  }
});

export const { setPageName, clearPageName } = pageNameSlice.actions;
export default pageNameSlice.reducer;